import React, { useState, useEffect } from 'react';
import { get, post } from '../utils/api';
import { useAuth } from '../context/AuthContext';
const fmt = n => '₦' + Number(n||0).toLocaleString('en-NG');

export default function Cashbook() {
  const { hasPermission } = useAuth();
  const [data, setData] = useState({ data:[], summary:[] });
  const [loading, setLoading] = useState(true);
  const [account, setAccount] = useState('');
  const [modal, setModal] = useState(false);

  const load = () => {
    setLoading(true);
    const qs = account ? '?account='+account : '';
    get('/cashbook'+qs).then(setData).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, [account]);

  const cash = data.summary.find(s => s.account==='cash');
  const bank = data.summary.find(s => s.account==='bank');

  return (
    <div>
      <div className="flex-between mb-lg">
        <h2 className="page-title">Cashbook</h2>
        {hasPermission('cashbook:write') && (
          <button className="btn btn-primary" onClick={() => setModal(true)}>+ Manual Entry</button>
        )}
      </div>
      <div className="metrics" style={{gridTemplateColumns:'repeat(3,1fr)'}}>
        <div className="tile"><div className="tile-lbl">Cash on Hand</div><div className="tile-val pos">{fmt(cash?.balance||0)}</div></div>
        <div className="tile"><div className="tile-lbl">Bank Balance</div><div className="tile-val pos">{fmt(bank?.balance||0)}</div></div>
        <div className="tile"><div className="tile-lbl">Total Funds</div><div className="tile-val pos">{fmt((parseFloat(cash?.balance||0))+(parseFloat(bank?.balance||0)))}</div></div>
      </div>
      <p className="text-muted text-sm">Cashbook totals include unassigned entries. Banking and dashboard balances use entries assigned to an account.</p>
      <div className="search-bar">
        <select value={account} onChange={e => setAccount(e.target.value)}>
          <option value="">All accounts</option>
          <option value="cash">Cash</option>
          <option value="bank">Bank</option>
        </select>
      </div>
      <div className="tbl-wrap">
        {loading ? <div className="spinner"></div> : (
          <table>
            <thead><tr><th>Date</th><th>Description</th><th>Type</th><th>Account</th><th style={{textAlign:'right'}}>Amount</th></tr></thead>
            <tbody>
              {data.data.length === 0
                ? <tr><td colSpan="5"><div className="empty-state"><h3>No transactions yet</h3></div></td></tr>
                : data.data.map(t => (
                  <tr key={t.id}>
                    <td>{t.date}</td><td>{t.description}</td>
                    <td><span className={'badge '+(t.type==='inflow'?'b-paid':'b-unpaid')}>{t.type}</span></td>
                    <td><span className="badge b-grey">{t.account_name || 'Unassigned ('+t.account+')'}</span></td>
                    <td className="amt" style={{color:t.type==='inflow'?'var(--paid)':'var(--unpaid)'}}>
                      {t.type==='outflow'?'-':'+'}{ fmt(t.amount)}
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )}
      </div>
      {modal && <CashModal onClose={() => setModal(false)} onSaved={() => { setModal(false); load(); }} />}
    </div>
  );
}

function CashModal({ onClose, onSaved }) {
  const [form, setForm] = useState({ date:new Date().toISOString().split('T')[0], type:'inflow', amount:'', account:'bank', bank_account_id:'', description:'' });
  const [accounts,setAccounts]=useState([]);
  const [error,setError]=useState('');
  useEffect(()=>{get('/bank-accounts').then(d=>setAccounts(d.data||[])).catch(e=>setError(e.message));},[]);
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    if(!form.bank_account_id){setError('Select the account used');return;}
    setSaving(true);setError('');
    try { await post('/cashbook', form); onSaved(); } catch(e){setError(e.message);}finally { setSaving(false); }
  };
  return (
    <div className="modal-overlay"><div className="modal">
      <div className="modal-hdr">
        <span className="modal-title">Manual Entry</span>
        <button className="btn btn-ghost btn-sm" onClick={onClose}>✕</button>
      </div>
      <div className="modal-body">
        {error && <div className="alert alert-error">{error}</div>}
        <div className="form-row">
          <div className="form-group"><label className="form-label">Date *</label>
            <input type="date" className="form-control" value={form.date} onChange={e=>setForm({...form,date:e.target.value})} /></div>
          <div className="form-group"><label className="form-label">Type *</label>
            <select className="form-control" value={form.type} onChange={e=>setForm({...form,type:e.target.value})}>
              <option value="inflow">Inflow (Money In)</option>
              <option value="outflow">Outflow (Money Out)</option>
            </select></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label className="form-label">Amount (N) *</label>
            <input type="number" className="form-control" value={form.amount} onChange={e=>setForm({...form,amount:e.target.value})} /></div>
          <div className="form-group"><label className="form-label">Account *</label>
            <select className="form-control" value={form.account} onChange={e=>setForm({...form,account:e.target.value,bank_account_id:''})}>
              <option value="bank">Bank</option><option value="cash">Cash</option>
            </select></div>
        </div>
        <div className="form-group"><label className="form-label">Transaction account *</label>
          <select className="form-control" value={form.bank_account_id} onChange={e=>setForm({...form,bank_account_id:e.target.value})}>
            <option value="">Select account...</option>
            {accounts.filter(a=>a.type===form.account).map(a=><option key={a.id} value={a.id}>{a.name}</option>)}
          </select></div>
        <div className="form-group"><label className="form-label">Description *</label>
          <input className="form-control" value={form.description} onChange={e=>setForm({...form,description:e.target.value})} /></div>
      </div>
      <div className="modal-ftr">
        <button className="btn btn-outline" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={submit} disabled={saving}>{saving?'Saving...':'Add Entry'}</button>
      </div>
    </div></div>
  );
}
